import { AmenitySvg, AmenitySvgProps } from "./AmenitySvg";

export function ElevatorIcon(props: AmenitySvgProps) {
  return (
    <AmenitySvg {...props}>
      <path
        d="M5.5 15C5.5 10.5217 5.5 8.28249 6.89124 6.89124C8.28249 5.5 10.5217 5.5 15 5.5C19.4783 5.5 21.7175 5.5 23.1088 6.89124C24.5 8.28249 24.5 10.5217 24.5 15C24.5 19.4783 24.5 21.7175 23.1088 23.1088C21.7175 24.5 19.4783 24.5 15 24.5C10.5217 24.5 8.28249 24.5 6.89124 23.1088C5.5 21.7175 5.5 19.4783 5.5 15Z"
        stroke="currentColor"
        strokeWidth={1.5}
      />
      <path
        d="M12 11V19M12 11C11.2052 11 10 13 10 13M12 11C12.7822 11 14 13 14 13M18 19V11M18 19C17.2178 19 16 17 16 17M18 19C18.7822 19 20 17 20 17"
        stroke="currentColor"
        strokeWidth={1.55}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </AmenitySvg>
  );
}
